import { callApi, Proxy } from 'utils';
import { uploadVideoModel } from 'common/api/models/upload-video';
import { uploadProgressAction } from 'pages/upload.page/actions';
import { showDialogAction } from 'components/redux-dialog/actions';
import { UPLOAD_FAILED_DIALOG } from 'pages/upload.page/publish-video/fragments';
import { getNewRelicAgent } from 'newRelicAgent';
/**
 * @return {Promise<uploadVideoModel>}
 */
export const createVideoApi = () => callApi('upload', 'POST').then(uploadVideoModel);

/**
 * @param {string} uploadUrl
 * @param {Blob} chunk
 * @param {string} currentChunkNumber
 * @param {string} totalChunks
 */
export const chunkUploadApi = (uploadUrl, chunk, currentChunkNumber, totalChunks) =>
  new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    const { dispatch } = Proxy;
    Proxy.uploadXHR = xhr;

    xhr.onload = (event) => {
      const response = event.currentTarget;

      if (response.status > 202) {
        getNewRelicAgent().noticeError(
          new Error(`Chunk UPLOAD failed. Chunk number: ${currentChunkNumber}. Total chunks: ${totalChunks}`)
        );
        dispatch(showDialogAction(UPLOAD_FAILED_DIALOG));
        reject({
          message: response.responseText,
          statusCode: response.status,
        });
        return false;
      }

      if (totalChunks === currentChunkNumber) {
        dispatch(uploadProgressAction(100, +currentChunkNumber + 1, +totalChunks + 1));
      }

      dispatch(uploadProgressAction(100, +currentChunkNumber, +totalChunks + 1));

      resolve();
    };

    xhr.upload.addEventListener('progress', ({ loaded, total }) => {
      dispatch(uploadProgressAction(Math.ceil((100 * loaded) / total), +currentChunkNumber, +totalChunks + 1));
    });

    xhr.open('POST', uploadUrl, true);
    xhr.setRequestHeader('Content-Type', 'application/octet-stream');
    xhr.setRequestHeader('Mi24-Upload-Current-Chunk', currentChunkNumber);
    xhr.setRequestHeader('Mi24-Upload-Total-Chunks', totalChunks);
    xhr.send(chunk);
  });

/**
 * @param {string} videoId
 * @param {*} postData
 * @return {Promise<T>}
 */
export const updateVideoApi = (videoId, postData) => callApi(`upload/${videoId}`, 'POST', postData);
